// extracted by mini-css-extract-plugin
export var $animation_name = "MenuFooter-module--$animation_name--a9402";
export var MenuFooter = "MenuFooter-module--MenuFooter--e53d3";
export var MenuFooter___desktop = "MenuFooter-module--MenuFooter___desktop--1c19a";
export var MenuFooter___mobile = "MenuFooter-module--MenuFooter___mobile--8a9d1";
export var MenuFooter__blurb = "MenuFooter-module--MenuFooter__blurb--69e17";
export var MenuFooter__logos = "MenuFooter-module--MenuFooter__logos--a16ed";
export var MenuFooter__logos___madeForThis = "MenuFooter-module--MenuFooter__logos___madeForThis--480ea";